import { render, staticRenderFns } from "./slack-callback.vue?vue&type=template&id=3d54707b&scoped=true&"
import script from "./slack-callback.vue?vue&type=script&lang=js&"
export * from "./slack-callback.vue?vue&type=script&lang=js&"
import style0 from "./slack-callback.vue?vue&type=style&index=0&id=3d54707b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54707b",
  null
  
)

export default component.exports